export const Theme = {
  // fonts
  PrimaryFont: "Open Sans",
  SecondaryFont: "Montserrat",
  DesignFont: "Expletus Sans",

  // font-weight
  FontWeightThin: "100",
  FontWeightExtraLight: "200",
  FontWeightLight: "300",
  FontWeightRegular: "400",
  FontWeightMedium: "500",
  FontWeightBold: "700",
  FontWeightBlack: "900",

  // font size
  FontSizeXS: "12px",
  FontSizeSmall: "15px",
  FontSizeRegular: "16px",
  FontSizeMedium: "22px",
  FontSizeLarge: "28px",
  FontSizeXL: "34px",
  FontSizeXXL: "46px",

  // colors
  PrimaryColor: "#83C5BE", // rgb(131, 197, 190)
  PrimaryColorDark: "#006D77", // rgb(0, 109, 119)
  SecondaryColor: "#ffdfd2", // rgb(255, 221, 210)
  SecondaryColorDark: "#E29578", // rgb(226, 149, 120)
  BackgroundColorLight: "#EDF6F9", // rgb(237, 246, 249)
  TextColorFaded: "#333 ",

  // Margin
  MarginSmall: "0.7rem",
  MarginRegular: "1rem",
  MarginMedium: "1.5rem",
  MarginLarge: "2rem",
  MarginXL: "4rem",
  MarginXXL: "8rem",

  // Padding
  PaddingSmall: "0.7rem",
  PaddingRegular: "1rem",
  PaddingMedium: "1.5rem",
  PaddingLarge: "2rem",
  PaddingXL: "4rem",
  PaddingXXL: "10rem",

  // border-radius
  BorderRadiusSmall: "5px",
  BorderRadiusMedium: "10px",
  BorderRadiusLarge: "20px",
  BorderRadiusXL: "40px",
  BorderRadiusRound: "50%",
};
